import { gql } from '@apollo/client';

export const DELETE_WORKSPACE_DATASET = gql`
  mutation deleteWorkspaceDataset($id: ID!) {
    workspaceDataset: deleteWorkspaceDataset(id: $id) {
      id
    }
  }
`;
